/* This is your custom Javascript */
import Collapse from 'bootstrap/js/dist/collapse';
import MicroModal from 'micromodal';
import actTranslations from './lib/actTranslations';
import joinAct from './lib/joinAct';
import bioPromise from './lib/bioPromise';
import review from './lib/review';

document.addEventListener("DOMContentLoaded", function(event) { 
  joinAct.init();
  bioPromise.init();
  review.init();
  actTranslations.init();
  MicroModal.init();
});
